export default __webpack_public_path__ + "static/media/icons_quotes.3da02f97.svg";